export function getPurchasedDate(date?: number | null, locales?: string) {
  const purchaseDate = date ? new Date(date) : new Date();
  // Expected in the format: '10-03-2022'
  return purchaseDate.toLocaleDateString(locales || 'en-GB').replace(/\//g, '-');
}
